import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './home_page/HomePage';
import Footer from './footer_file/Footer';
import Header from './header/Header'; // Import Header component
import About from './about/About'; // Import Header component
import ContactPage from './contact/ContactPage'; // Import Header component
import ServicePage from './service/ServicePage'; // Import Header component
import IphoneAppDevelopment from './app_development/IphoneAppDevelopment'; // Import Header component
import AndroidAppDevelopment from './app_development/AndroidAppDevelopment'; // Import Header component
import CrossPlatformApp  from './app_development/CrossPlatformApp'; // Import Header component
import MobileConsulting  from './app_development/MobileConsulting'; // Import Header component
import WebDesignPage   from './webdevelopment/WebDesignPage'; // Import Header component
import Hosting   from './app_development/Hosting'; // Import Header component
import Logic   from './backend/Logic'; // Import Header component
import Api   from './backend/Api'; // Import Header component
import Security   from './backend/Security'; // Import Header component
import Time   from'./timeline/Time'; // Import Header component
import AboutAdd from './home_page/AboutAdd';
import Home from './home_page/Home';
import HomeAdd from './home_page/HomeAdd';
import Desktop from './desktop/Desktop';

import ScrollToTop from './ScrollToTop';









function App() {
  return (

    <Router>
      <div className="app-container">
      <ScrollToTop />

        {/* Header will appear on all pages */}
        <Header /> 

        <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/" element={<HomePage />} />
          <Route path="About/" element={<About />} />
          <Route path="ContactPage/" element={<ContactPage />} />

          <Route path="ServicePage/" element={<ServicePage />} />
          <Route path="IphoneAppDevelopment/" element={<IphoneAppDevelopment />} />
          <Route path="AndroidAppDevelopment/" element={<AndroidAppDevelopment />} />
          <Route path="CrossPlatformApp/" element={<CrossPlatformApp/>} />
          <Route path="MobileConsulting/" element={<MobileConsulting/>} />
          <Route path="WebDesignPage/" element={<WebDesignPage/>} />
          <Route path="Hosting/" element={<Hosting/>} />
          <Route path="Api/" element={<Api/>} />
          <Route path="Logic/" element={<Logic/>} />
          <Route path="Security/" element={<Security/>} />
          <Route path="Time/" element={<Time/>} />
          <Route path="AboutAdd/" element={<AboutAdd/>} />
          <Route path="HomeAdd/" element={<HomeAdd/>} />
          <Route path="Desktop/" element={<Desktop/>} />



          {/* Add more routes as needed */}
        </Routes>
        
        {/* Footer will appear on all pages */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
